import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@songtradr-one/components-frontend";
import { App } from "./app/App";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <StrictMode>
    <ThemeProvider mode="dark">
      <App />
    </ThemeProvider>
  </StrictMode>,
);
